var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "pl-30 pr-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "auto" },
                },
                [
                  _c("h4", [_vm._v("充电宝押金退款模式：")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "充电宝原路退回:" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.form.cdb_drawbacke_balance,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "cdb_drawbacke_balance", $$v)
                            },
                            expression: "form.cdb_drawbacke_balance",
                          },
                        },
                        [_vm._v(" ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.drawbacke_now_cdb,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "drawbacke_now_cdb", $$v)
                            },
                            expression: "form.drawbacke_now_cdb",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "1" } }, [
                            _vm._v("立即退"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: "0" } }, [
                            _vm._v("延时退"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.drawbacke_now_cdb == 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "延长时间:" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                oninput: "value=value.replace(/[^\\d.]/g,'')",
                              },
                              model: {
                                value: _vm.form.drawbacke_hours_cdb,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "drawbacke_hours_cdb", $$v)
                                },
                                expression: "form.drawbacke_hours_cdb",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("小时"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "充电宝退回钱包作为押金:" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.form.cdb_drawbacke_balance,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "cdb_drawbacke_balance", $$v)
                            },
                            expression: "form.cdb_drawbacke_balance",
                          },
                        },
                        [_vm._v(" ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", [_vm._v("其它押金退款模式(充电线、套套机等)：")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "其它原路退回:" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.form.drawbacke_2_balance,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "drawbacke_2_balance", $$v)
                            },
                            expression: "form.drawbacke_2_balance",
                          },
                        },
                        [_vm._v(" ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.drawbacke_now,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "drawbacke_now", $$v)
                            },
                            expression: "form.drawbacke_now",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "1" } }, [
                            _vm._v("立即退"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: "0" } }, [
                            _vm._v("延时退"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.drawbacke_now == 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "延长时间:" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                oninput: "value=value.replace(/[^\\d.]/g,'')",
                              },
                              model: {
                                value: _vm.form.drawbacke_hours,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "drawbacke_hours", $$v)
                                },
                                expression: "form.drawbacke_hours",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("小时"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "其它退回钱包作为押金:" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.form.drawbacke_2_balance,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "drawbacke_2_balance", $$v)
                            },
                            expression: "form.drawbacke_2_balance",
                          },
                        },
                        [_vm._v(" ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-20" }, [
                    _vm._v("充电桩原路退回："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否开启:" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.cdz_drawbacke_balance,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cdz_drawbacke_balance", $$v)
                          },
                          expression: "form.cdz_drawbacke_balance",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-20" }, [
                    _vm._v("提现方式设置："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "提现方式:" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { min: 1 },
                          model: {
                            value: _vm.form.agent_withdraw_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "agent_withdraw_type", $$v)
                            },
                            expression: "form.agent_withdraw_type",
                          },
                        },
                        [
                          _c("el-checkbox", { attrs: { label: "0" } }, [
                            _vm._v("银行卡"),
                          ]),
                          _vm._v(" "),
                          _c("el-checkbox", { attrs: { label: "1" } }, [
                            _vm._v("微信"),
                          ]),
                          _vm._v(" "),
                          _c("el-checkbox", { attrs: { label: "2" } }, [
                            _vm._v("支付宝"),
                          ]),
                          _vm._v(" "),
                          _c("el-checkbox", { attrs: { label: "3" } }, [
                            _vm._v("微信收款码"),
                          ]),
                          _vm._v(" "),
                          _c("el-checkbox", { attrs: { label: "4" } }, [
                            _vm._v("支付宝收款码"),
                          ]),
                          _vm._v(" "),
                          _c("el-checkbox", { attrs: { label: "5" } }, [
                            _vm._v("发票对公"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-20" }, [
                    _vm._v("平台对公设置："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公司抬头名称:" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.ent_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ent_name", $$v)
                          },
                          expression: "form.ent_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发票组织机构代码:" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.org_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "org_code", $$v)
                          },
                          expression: "form.org_code",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-20" }, [
                    _vm._v("代理提现设置："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "一天最多提现次数:" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            oninput: "value=value.replace(/[^\\d.]/g,'')",
                          },
                          model: {
                            value: _vm.form.agent_tx_day_num,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "agent_tx_day_num", $$v)
                            },
                            expression: "form.agent_tx_day_num",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("次")])],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "需审核金额:" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            oninput: "value=value.replace(/[^\\d.]/g,'')",
                          },
                          model: {
                            value: _vm.form.agent_audit_min_yuan,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "agent_audit_min_yuan", $$v)
                            },
                            expression: "form.agent_audit_min_yuan",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("元")])],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手续费模式:" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.form.agent_withdraw_fee_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "agent_withdraw_fee_type", $$v)
                            },
                            expression: "form.agent_withdraw_fee_type",
                          },
                        },
                        [_vm._v("税点")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.form.agent_withdraw_fee_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "agent_withdraw_fee_type", $$v)
                            },
                            expression: "form.agent_withdraw_fee_type",
                          },
                        },
                        [_vm._v("手续费")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 2 },
                          model: {
                            value: _vm.form.agent_withdraw_fee_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "agent_withdraw_fee_type", $$v)
                            },
                            expression: "form.agent_withdraw_fee_type",
                          },
                        },
                        [_vm._v("税点+手续费")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-wrap" },
                    [
                      _c("el-form-item", { attrs: { label: "税点:" } }, [
                        _c(
                          "div",
                          { staticClass: "mb-10 flex align-center" },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.form.agent_withdraw_percent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "agent_withdraw_percent",
                                      $$v
                                    )
                                  },
                                  expression: "form.agent_withdraw_percent",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "手续费:" } }, [
                        _c(
                          "div",
                          { staticClass: "flex align-center" },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.form.agent_withdraw_fee,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "agent_withdraw_fee",
                                      $$v
                                    )
                                  },
                                  expression: "form.agent_withdraw_fee",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-wrap" },
                    [
                      _c("el-form-item", { attrs: { label: "最小金额:" } }, [
                        _c(
                          "div",
                          { staticClass: "mb-10 flex align-center" },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.form.agent_withdraw_min_yuan,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "agent_withdraw_min_yuan",
                                      $$v
                                    )
                                  },
                                  expression: "form.agent_withdraw_min_yuan",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "最大金额:" } }, [
                        _c(
                          "div",
                          { staticClass: "flex align-center" },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.form.agent_withdraw_max_yuan,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "agent_withdraw_max_yuan",
                                      $$v
                                    )
                                  },
                                  expression: "form.agent_withdraw_max_yuan",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("withdraw-plan", {
                    attrs: { form: _vm.form, name: "agent" },
                  }),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-20" }, [
                    _vm._v("商家提现设置："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "一天最多提现次数:" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            oninput: "value=value.replace(/[^\\d.]/g,'')",
                          },
                          model: {
                            value: _vm.form.merchant_tx_day_num,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "merchant_tx_day_num", $$v)
                            },
                            expression: "form.merchant_tx_day_num",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("次")])],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "需审核金额:" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            oninput: "value=value.replace(/[^\\d.]/g,'')",
                          },
                          model: {
                            value: _vm.form.merchant_audit_min_yuan,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "merchant_audit_min_yuan", $$v)
                            },
                            expression: "form.merchant_audit_min_yuan",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("元")])],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手续费模式:" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.form.merchant_withdraw_fee_type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "merchant_withdraw_fee_type",
                                $$v
                              )
                            },
                            expression: "form.merchant_withdraw_fee_type",
                          },
                        },
                        [_vm._v("税点")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.form.merchant_withdraw_fee_type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "merchant_withdraw_fee_type",
                                $$v
                              )
                            },
                            expression: "form.merchant_withdraw_fee_type",
                          },
                        },
                        [_vm._v("手续费")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 2 },
                          model: {
                            value: _vm.form.merchant_withdraw_fee_type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "merchant_withdraw_fee_type",
                                $$v
                              )
                            },
                            expression: "form.merchant_withdraw_fee_type",
                          },
                        },
                        [_vm._v("税点+手续费")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-wrap" },
                    [
                      _c("el-form-item", { attrs: { label: "税点:" } }, [
                        _c(
                          "div",
                          { staticClass: "mb-10 flex align-center" },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.form.merchant_withdraw_percent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "merchant_withdraw_percent",
                                      $$v
                                    )
                                  },
                                  expression: "form.merchant_withdraw_percent",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "手续费:" } }, [
                        _c(
                          "div",
                          { staticClass: "flex align-center" },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.form.merchant_withdraw_fee,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "merchant_withdraw_fee",
                                      $$v
                                    )
                                  },
                                  expression: "form.merchant_withdraw_fee",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-wrap" },
                    [
                      _c("el-form-item", { attrs: { label: "最小金额:" } }, [
                        _c(
                          "div",
                          { staticClass: "mb-10 flex align-center" },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.form.merchant_withdraw_min_yuan,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "merchant_withdraw_min_yuan",
                                      $$v
                                    )
                                  },
                                  expression: "form.merchant_withdraw_min_yuan",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "最大金额:" } }, [
                        _c(
                          "div",
                          { staticClass: "flex align-center" },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.form.merchant_withdraw_max_yuan,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "merchant_withdraw_max_yuan",
                                      $$v
                                    )
                                  },
                                  expression: "form.merchant_withdraw_max_yuan",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("withdraw-plan", {
                    attrs: { form: _vm.form, name: "merchant" },
                  }),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-20" }, [
                    _vm._v("用户提现设置："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-wrap" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "金额大于:" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                oninput: "value=value.replace(/[^\\d.]/g,'')",
                              },
                              model: {
                                value: _vm.form.user_audit_min_yuan,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "user_audit_min_yuan", $$v)
                                },
                                expression: "form.user_audit_min_yuan",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元无需审核"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "手续费:" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                oninput: "value=value.replace(/[^\\d.]/g,'')",
                              },
                              model: {
                                value: _vm.form.user_withdraw_percent,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "user_withdraw_percent",
                                    $$v
                                  )
                                },
                                expression: "form.user_withdraw_percent",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-wrap" },
                    [
                      _c("el-form-item", { attrs: { label: "最小金额:" } }, [
                        _c(
                          "div",
                          { staticClass: "mb-10 flex align-center" },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.form.user_withdraw_min_yuan,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "user_withdraw_min_yuan",
                                      $$v
                                    )
                                  },
                                  expression: "form.user_withdraw_min_yuan",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "最大金额:" } }, [
                        _c(
                          "div",
                          { staticClass: "flex align-center" },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.form.user_withdraw_max_yuan,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "user_withdraw_max_yuan",
                                      $$v
                                    )
                                  },
                                  expression: "form.user_withdraw_max_yuan",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "押金提现退款模式:" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.user_withdraw_by_refund,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "user_withdraw_by_refund", $$v)
                          },
                          expression: "form.user_withdraw_by_refund",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "fs-s2 text-gray" }, [
                        _vm._v("注：开启表示用户从钱包提现。"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-20" }, [
                    _vm._v("用户相关设置："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号权限:" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.register_user_moblie,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "register_user_moblie", $$v)
                          },
                          expression: "form.register_user_moblie",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "fs-s2 text-gray" }, [
                        _vm._v(
                          "注：开启表示支付宝小程序已获得获取用户手机号权限，用户注册必须授权手机号。"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-20" }, [_vm._v("首单免费：")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否开启:" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.first_free_right,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "first_free_right", $$v)
                          },
                          expression: "form.first_free_right",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-20" }, [
                    _vm._v("订单分成明细："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否显示:" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.order_profits_detail_show,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "order_profits_detail_show", $$v)
                          },
                          expression: "form.order_profits_detail_show",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.powerInfo.buy_goods_right
                    ? [
                        _c("h4", { staticClass: "pt-20" }, [
                          _vm._v("设备出售："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex flex-wrap" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "售卖状态:" } },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                  },
                                  model: {
                                    value: _vm.form.sell_goods_switch,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "sell_goods_switch",
                                        $$v
                                      )
                                    },
                                    expression: "form.sell_goods_switch",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "默认商户ID:" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    oninput:
                                      "value=value.replace(/[^\\d.]/g,'')",
                                  },
                                  model: {
                                    value: _vm.form.selled_goods_bind_sid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "selled_goods_bind_sid",
                                        $$v
                                      )
                                    },
                                    expression: "form.selled_goods_bind_sid",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "fs-s2 text-gray" }, [
                                  _vm._v(
                                    "注：用户购买设备后，设备将会绑定到此商户，商户ID可在商户列表查到。"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }